module.exports = __webpack_public_path__ + "static/media/model_zh.bd2020cd.png";